import React from 'react'
import { Link, NavLink } from 'react-router-dom'
import {BsSearch} from 'react-icons/bs'

const Header = () => {
  return (
    <>
        <div className="header-top-strip py-3">
            <div className="container-xxl">
                <div className="row">
                    <div className="col-6">
                        <p className="text-white mb-0">Free Shopping Over $100 & Free Returns</p>
                    </div>
                    <div className="col-6">
                        <p className="text-white text-end mb-0">
                            Hotline: <a className="text-white" href="tel:+93 799225732">+93 799225732</a>
                        </p>    
                    </div>
                </div>
            </div>
        </div>
        <div className="header-upper py-3">
            <div className="container-xxl">
                <div className="row align-items-center">
                    <div className="col-2">
                        <h2>
                            <Link className="text-white">Rahmat Store</Link>
                        </h2>
                    </div>
                    <div className="col-5">
                        <div className="input-group">
                            <input type="text" className="form-control" placeholder="Search product here..."  aria-describedby='basic-addon2' />
                            <span className="input-group-text p-2" id='basic-addon2'>
                                <BsSearch className="fs-6 text-dark" />
                            </span>
                        </div>
                    </div>
                    <div className="col-5">
                        <div className="header-upper-links d-flex justify-content-between align-items-center">
                            <div>
                                <Link to="/compare-product" className="d-flex align-items-center gap-10 text-white">
                                    <img src="/images/compare.svg" alt="compare" />
                                    <p className="mb-0">Compare <br/> Products</p>
                                </Link>
                            </div>
                            <div>
                                <Link to="/wishlist" className="d-flex align-items-center gap-10 text-white">
                                    <img src="/images/wishlist.svg" alt="wishlist" />
                                    <p className="mb-0">Favourite <br/> Wishlist</p>
                                </Link>
                            </div>
                            <div>
                                <Link to="/login" className="d-flex align-items-center gap-10 text-white">
                                    <img src="/images/user.svg" alt="user" />
                                    <p className="mb-0">Login <br/> My Account</p>
                                </Link>
                            </div>
                            <div>
                                <Link to="/cart" className="d-flex align-items-center gap-10 text-white">
                                    <img src="/images/cart.svg" alt="cart" />
                                    <div className="d-flex flex-column gap-10">
                                        <span className="badge bg-white text-dark">0</span>
                                        <p className="mb-0">$ 500</p>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="header-bottom py-3">
            <div className="container-xxl">
                <div className="row">
                    <div className="col-12">
                        <div className="menu-bottom d-flex align-items-center gap-30">
                            <div>
                                <div className="dropdown">
                                    <button 
                                        className='btn btn-secondary dropdown-toggle bg-transparent border-0 gap-15 d-flex align-items-center' 
                                        type='button' id='dropdownMenuButton1' 
                                        data-bs-toggle="dropdown" 
                                        aria-expanded="false">
                                            <img src='images/menu.svg' alt="mene" height="25" width="25"/>
                                            <span className='me-2 d-inline-block'>Shop Categories</span>
                                    </button>   
                                    <ul className='dropdown-menu' aria-labelledby='dropdownMenuButton1'>
                                        <li className='dorpdown-item'>
                                            <Link className="dropdown-item text-white" to="#">Action</Link>
                                        </li>
                                        <li className='dorpdown-item'>
                                            <Link className="dropdown-item text-white" to="#">Action</Link>
                                        </li>
                                        <li className='dorpdown-item'>
                                            <Link className="dropdown-item text-white" to="#">Action</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="menu-links">
                                <div className="d-flex align-items-center gap-15">
                                    <NavLink to="/">Home</NavLink>
                                    <NavLink to="/store">Our Store</NavLink>
                                    <NavLink to="/blogs">Blogs</NavLink>
                                    <NavLink to="/contact">Contact</NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default Header